const KEY = "sayn.sessionExpired";
const MAX_SETTIMEOUT_MS = 2147483647;

/**
 * Remembers that the session ended because the JWT expired.
 * @returns {void}
 */
export const markSessionExpired = () => {
  try {
    localStorage.setItem(KEY, "1");
  } catch (err) {
    // storage may be unavailable
  }
};

/**
 * Clears the expired-session marker so the login form can show.
 * @returns {void}
 */
export const clearSessionExpired = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    // storage may be unavailable
  }
};

/**
 * Whether the login page should show the expired-session message.
 * @returns {boolean}
 */
export const isSessionExpired = () => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch (err) {
    return false;
  }
};

/**
 * Delay until JWT exp, capped so setTimeout does not overflow (max ~24.8 days).
 * @param {number} expiresAtMs JWT exp as milliseconds since epoch
 * @returns {number} Milliseconds to wait (0 if already expired)
 */
export const sessionExpiryTimeoutMs = (expiresAtMs) => {
  const remaining = expiresAtMs - Date.now();
  if (remaining <= 0) {
    return 0;
  }
  return Math.min(remaining, MAX_SETTIMEOUT_MS);
};
